import { render, staticRenderFns } from "./adjustConfig.vue?vue&type=template&id=8f9e5ef4"
import script from "./adjustConfig.vue?vue&type=script&lang=js"
export * from "./adjustConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports